module.exports = __webpack_public_path__ + "static/media/logoorange.86f81667.png";